import { axiosClient } from '@nx-frontend/shared/api';
import { SearchTasksResponse } from '@nx-frontend/shared/types';

export interface SearchTasksParams {
  sessionId: string;
  gatewayUrl: string;
  query: {
    filters?: {
      workspaceIds?: string[];
      taskIds?: string[];
      taskListIds?: string[];
      assigneeUserIds?: number[];
      labelKeys?: string[];
      deadlines?: string[];
      noteKeys?: string[];
      types?: string[];
    };
    offset?: number;
    limit?: number;
    pit?: string;
    searchUntilTaskId?: string;
    throwNotFoundError?: boolean;
  };
}

export async function searchTasks({
  gatewayUrl,
  sessionId,
  query,
}: SearchTasksParams): Promise<SearchTasksResponse | null> {
  try {
    const response = await axiosClient.post<SearchTasksResponse>(
      `${gatewayUrl}/ft:tasks/tasks/search`,
      { ...query },
      {
        headers: {
          'Content-Type': 'application/json',
          'everhelper-session-id': sessionId,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error('Fail to get tasks by filters: ', query.filters);
  }
  return null;
}
